// extracted by mini-css-extract-plugin
export default {"musicContainer1":"MusicContainer_musicContainer1__IDE8g","textH2":"MusicContainer_textH2__pmaNP","musicContainer2":"MusicContainer_musicContainer2__pHXCa"};